import { ref } from 'vue'
import { defineStore } from 'pinia'

export const globalStore = defineStore('global', () => {

  const isLoadingShow = ref<boolean>(false)

  function setLoadingValue(isShowV:boolean) {
    isLoadingShow.value = isShowV;
  }

  // 日期处理
  function getDateByFormat(date:string){
    if(date){
      let myDate = new Date(date);
      return myDate.getFullYear() + '年' + ((myDate.getMonth()+1)<10?'0':'') + (myDate.getMonth()+1) + '月' + (myDate.getDate()<10?'0':'') + myDate.getDate() + '日';
    }else{
      return '';
    }
  }

  const searchValue = ref(null)

  function setSearchValue(value: any){
    searchValue.value = value;
  }
  
  function clearSearchValue(){
    searchValue.value = null;
  }

  return { isLoadingShow, searchValue, setLoadingValue, getDateByFormat, setSearchValue, clearSearchValue }
})
